import {FETCH_PROFILE_DATA_REQUEST, FETCH_PROFILE_DATA_SUCCESS, FETCH_PROFILE_DATA_FAILURE} from '../constants';

const initialState = {
  data: null,
  loading: false,
  error: null,
};

const profileReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_PROFILE_DATA_REQUEST:
      return { ...state, loading: true, error: null };
    case FETCH_PROFILE_DATA_SUCCESS:
      return { ...state, loading: false, data: action.payload };
    case FETCH_PROFILE_DATA_FAILURE:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};

export default profileReducer;